import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import ContactForm from '../components/contact/contact-form';
import ContactAddress from '../components/contact/contact-address-text';
import ContactPhone from '../components/contact/contact-phone';
import ContactEmail from '../components/contact/contact-email';
import LogoComponent from '../components/logo-comp';
import AppointmentForm from '../components/appointment/appointment-form';
import AppointmentComp from '../components/appointment/appointment-comp';
import { Button } from 'react-bootstrap';
import { useState } from 'react';
import * as httpService from '../services/HTTPService';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AppointmentPage = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();      
    const makeAppointmentLbl = i18n.exists("forms.makeAppointmentLbl") ? t('forms.makeAppointmentLbl') : "Запазете час за среща"; 
    const appCreatedLbl = i18n.exists("forms.appCreatedLbl") ? t('forms.appCreatedLbl') : "Вие успешно записахте час с екипът на КАТЕ"; 
    const successRequestSend = i18n.exists("forms.successRequestSend") ? t('forms.successRequestSend') : "Вашата заявка за среща е изпратена успешно."; 
    let [dTime, setDTime] = useState(Object);
    let [isValidForm, setIsvalidForm] = useState(false);
    const [formData, setFormData] = useState(Object);
    const [appointmentCreated, setAppointmentCreated] = useState(false);
    // useEffect(() => {

    // }, [])

    const getFormData = (data: any) => {
        setFormData(data);
    }

    const makeAppointment = (e:any) => {
        e.preventDefault();
        if(dTime.time) {
            let d = new Date(dTime.date);
            const time = dTime.time.split(":");
            d.setHours(time[0]);
            d.setMinutes(time[1]);
            const body = {
                "email": formData.email,
                "fullName": formData.fullName,
                "meetingDateTime": d,
                "phoneNumber": formData.phoneNumber,
                "notes": ""
            }
            
            if(isValidForm && dTime.date && dTime.time) {
                httpService.sendMeetingRequest(body).then((res) => {
                    if(res) {
                        console.log(res)
                        //toast.success(successRequestSend);
                        // reset form
                        isValidForm = false;
                        setIsvalidForm(false);
                        setAppointmentCreated(true);
                        // setTimeout(() => {
                        //     navigate('/');
                        // }, 6000)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    toast.error(t('forms.commonErrMsg'));
                })
            }
        }
    }

    const getDateTime = (d: any) => {
        dTime = d;
        setDTime(d);
    }

    const validateForm = (isValid: boolean) => {
        isValidForm = isValid;
        setIsvalidForm(isValid);
    }

    const ovaerlayOnClick = () => {
        window.location.reload();
    }

    return (
        <div className="pg-form appointment-page">
            <ToastContainer />
            {appointmentCreated ? (
                <div className='overlay-out gr-color' onClick={ovaerlayOnClick}>
                    <div className='app-created'>
                        <h2>{appCreatedLbl}</h2>
                    </div>
                </div>
            ) : null}
            <Row className="mb-3">
                {/* <Col sm={5} md={4} lg={2} className="margin-0 form-bg-out">
                    <div className="form-bg"></div>
                </Col> */}
                <Col sm={12} md={12} lg={12} className="margin-0 bl-form-out">
                    <div className='mobile-contact-head'>
                        <LogoComponent logoColor="white" />
                        <div className='mobile-contact-head-in'></div>
                    </div>
                    <div className='bl-form'>
                        <div className="align-center logo-desc">
                            <a href="/"><img src="./img/Logo.png" /></a>
                        </div>
                        <div>
                            <h1>{makeAppointmentLbl}</h1>
                            <AppointmentForm isValidForm={validateForm} formData={getFormData} />
                            <AppointmentComp dateTime={getDateTime} />
                            <div className='align-center btn-out'>
                                <Button onClick={makeAppointment}>{makeAppointmentLbl}</Button>
                            </div>
                        </div>
                        <br />
                        <div className='white-txt'>
                            <ContactAddress />
                            <ContactPhone display="block" />
                            <ContactEmail display="block" />
                        </div>
                    </div>
                </Col>
            </Row>
    </div>
    )
}

export default AppointmentPage;